module.exports = __webpack_public_path__ + "media/images/success/dots_green-941239e9da81309cbc951e0f5962e6c3.png";